import * as httpHelper from '../../utils/http-helper';

function buscar(dataInicio: string, dataFim: string, idLotacao: string, cpf: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `RegistroBiometricoSemPrevisaoProducao?_cpf=${
      cpf
    }&_idLotacao=${
      idLotacao
    }&_dtInicio=${
      dataInicio
    }&_dtFim=${
      dataFim
    }`
  );
}

function buscarLotacoes(cpf: string, dataInicio: string, dataFim: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `RegistroBiometricoSemPrevisaoProducaoLotacoes?_cpf=${
      cpf
    }&_dataInicio=${
      dataInicio
    }&_dataFim=${
      dataFim
    }`
  );
}

const registroBiometricoService = {
  buscar,
  buscarLotacoes,
}

export default registroBiometricoService;
